import Rails from '@rails/ujs'

import 'form-request-submit-polyfill'
import { domReady } from '@/utils/dom-ready'

let initialized = false
let submittingForm = false

// global from Google reCAPTCHA script include.
/* eslint-disable no-undef */

export async function waitForRecaptchaLoaded(delay) {
  return new Promise((resolve, reject) => {
    if (typeof grecaptcha !== 'undefined' && grecaptcha !== null) {
      resolve(grecaptcha)
    } else {
      // delay up to 10 seconds, checking with an increasing backoff.
      if (delay < 10000) {
        console.log('delaying ' + delay)

        setTimeout(async function() {
          resolve(await waitForRecaptchaLoaded(delay * 2))
        }, delay)

      } else {
        reject('Google recaptcha service did not load')
      }
    }
  })
}

// export for jest test
export async function waitForRecaptchaToken(recaptchaLoader, tokenField, targetForm) {
  await waitForRecaptchaLoaded(200)
  return new Promise((resolve) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(window.Agra.Configuration.botProtection.siteKey, {
        action: targetForm.dataset['captchaAction']
      }).then((token) => {
        tokenField.value = token
        resolve(token)
      })
    })
  })
}

// This method is used to enable reCAPTCHA on rails-ujs forms (not forms rendered by Vue).
function setupRecaptcha() {
  if (initialized) {
    errorLogger.error('Re-initializing reCAPTCHA')
  }

  const recaptchaForms = Array.from(document.getElementsByClassName('bot-protected-form'))
  const recaptchaLoader = document.getElementById('recaptcha-loader')

  if (recaptchaForms !== null && recaptchaLoader !== null) {
    // A page may contain several forms protected by reCAPTCHA. Need to hook to
    // all of them to set the token on submit
    recaptchaForms.forEach( (recaptchaForm) => {
      recaptchaForm.addEventListener('ajax:complete', () => {
        submittingForm = false
      })

      // We handle the event `submit` here, not `ajax:before`,
      // because Rails full-page forms do not emit the event `ajax:before`.
      recaptchaForm.addEventListener('submit', (event) => {
        return recaptchaSubmit(event, recaptchaLoader)
      })
    })
  }
}

function recaptchaSubmit(event, recaptchaLoader) {
  console.log('performing submit')

  const targetForm = event.target
  // There may be more than one recaptcha token field in the page, so we ensure we retrieve
  // the correct one scoping the search to the currently submitted form.
  const tokenField = targetForm.querySelector('#recaptcha_token')

  // If the token has already been filled in, great! Submit the form
  if (tokenField.value.length > 0) {
    return true // continue with the form submit
  }

  // Don't go through with this submit, will be re-submitted after recaptcha
  // token is set and the .requestSubmit() call below is executed.
  event.preventDefault()
  event.stopPropagation()

  Rails.disableElement(targetForm)

  waitForRecaptchaToken(recaptchaLoader, tokenField, targetForm).then(function() {
    if (submittingForm) {
      errorLogger.error('Submitting form while last request hasn\'t finished yet')
    }
    submittingForm = true

    targetForm.requestSubmit() // Retry the submit now that we have a token
  })
  return false
}

function initialize() {
  document.addEventListener('form:loaded', () => {
    initialized = false
    setupRecaptcha()
    initialized = true
  })

  setupRecaptcha()
  initialized = true
}

document.addEventListener('turbolinks:load', initialize)
domReady(initialize)
